import { render, staticRenderFns } from "./adverts-activate.vue?vue&type=template&id=75632640"
import script from "./adverts-activate.vue?vue&type=script&lang=js"
export * from "./adverts-activate.vue?vue&type=script&lang=js"
import style0 from "./adverts-activate.vue?vue&type=style&index=0&id=75632640&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports